export const RECOVERY_NOTES_EMPTY_TITLE = 'No recovery notes yet';
export const RECOVERY_NOTES_EMPTY_SUBTITLE =
  'Notes added for asset recovery will appear here.';
export const RECOVERY_NOTES_EMPTY_IMAGE = 'assets/58x58/no_tickets.svg';
export const RECOVERY_NOTES_ADMIN_DESCRIPTION =
  'Record asset-related incidents (damage, loss, theft) for this employee. Notes are immutable and will auto-surface during offboarding. Settle a note once the recovery has been processed.';
export const RECOVERY_NOTES_READ_ONLY_DESCRIPTION =
  'Asset-related incidents (damage, loss, theft) recorded against you by the IT team. These notes are view-only and will be reviewed during your offboarding.';
export const RECOVERY_NOTES_EMPLOYEE_VIEW_DESCRIPTION =
  "Asset-related incidents (damage, loss, theft) recorded for this employee by the IT team. You can view these notes but cannot add or settle them. They will auto-surface during the employee's offboarding.";
export const RECOVERY_NOTES_IMMUTABLE_DESCRIPTION =
  'Recovery notes are immutable and cannot be edited or deleted.';
export const RECOVERY_NOTES_UNSETTLED_CHIP_SUFFIX = 'unsettled';
export const RECOVERY_NOTES_COMPLETED_CHIP = 'Completed';
export const RECOVERY_NOTES_ALL_SETTLED_CHIP = 'All settled';
export const RECOVERY_NOTES_NONE_CHIP = 'None';
export const RECOVERY_NOTE_MAX_LENGTH = 1000;
export const RECOVERY_NOTE_AMOUNT_MIN = 0.01;
export const RECOVERY_NOTE_AMOUNT_REQUIRED_ERROR = 'Recovery amount is required';
export const RECOVERY_NOTE_AMOUNT_INVALID_ERROR =
  'Recovery amount must be a number greater than 0';
export const RECOVERY_NOTE_CURRENCY_SYMBOL = '₹';
export const RECOVERY_NOTE_INCIDENT_PLACEHOLDER =
  'E.g., MacBook Pro damaged in transit on Sept 2 — screen replacement confirmed by IT hardware team';
export const RECOVERY_NOTE_ATTACHMENT_ALLOWED_EXTENSIONS = [
  'eml',
  'msg',
  'pdf',
  'jpg',
  'jpeg',
  'doc',
  'docx',
];
export const RECOVERY_NOTE_ATTACHMENT_ACCEPT = '.eml,.msg,.pdf,.jpg,.jpeg,.doc,.docx';
export const RECOVERY_NOTE_ATTACHMENT_MAX_TOTAL_BYTES = 10 * 1024 * 1024;
export const RECOVERY_NOTE_ATTACHMENT_MAX_COUNT = 10;
export const RECOVERY_NOTE_ATTACHMENT_DROP_LABEL =
  'Attach Email, PDF, JPG, DOC or DOCX — multiple files allowed';
export const RECOVERY_NOTE_ATTACHMENT_ADD_MORE_LABEL = 'Add more files';
export const RECOVERY_NOTE_ATTACHMENT_TYPE_ERROR =
  'Some files were not attached — unsupported file type. Allowed: Email, PDF, JPG, DOC, DOCX.';
export const RECOVERY_NOTE_ATTACHMENT_COUNT_ERROR = `You can attach up to ${RECOVERY_NOTE_ATTACHMENT_MAX_COUNT} files only.`;
export const RECOVERY_NOTES_PAGE_SIZE = 50;
export const RECOVERY_NOTE_PROGRESS_TICK_MS = 200;
export const RECOVERY_NOTE_PROGRESS_INCREMENT_MIN = 10;
export const RECOVERY_NOTE_PROGRESS_INCREMENT_SPAN = 10;
export const RECOVERY_NOTE_PROGRESS_SIMULATION_CAP = 90;
export const RECOVERY_NOTE_PROGRESS_COMPLETE = 100;
export const RECOVERY_NOTE_UPLOAD_COMPLETION_DISPLAY_MS = 500;
export const RECOVERY_NOTE_BYTES_PER_KB = 1024;
export const RECOVERY_NOTE_INCIDENT_COUNTER_FALLBACK_HEIGHT_PX = 20;
export const RECOVERY_NOTE_INCIDENT_COUNTER_GAP_PX = 4;
export const RECOVERY_NOTE_STATUS_SETTLED = 'SETTLED';
export const RECOVERY_NOTE_REMARK_MAX_LENGTH = 1000;
export const RECOVERY_NOTE_REMARK_MIN_LENGTH = 3;
export const RECOVERY_NOTE_REMARK_PLACEHOLDER =
  'e.g. fully recovered via salary deduction, partially settled, waived off by management.';
export const RECOVERY_NOTE_REMARK_ERROR = 'Please enter settlement remarks before confirming.';
export const RECOVERY_NOTE_SETTLE_SUCCESS = 'Recovery note settled successfully.';
export const RECOVERY_NOTE_SETTLE_ERROR = 'Failed to settle recovery note. Please try again.';
